export type CompanySSOSettings = {
  workerSsoEnabled: boolean;
  ogpSsoEnabled: boolean;
};

export type CompanySSOConnectionDetails = {
  entityId: string;
  assertionConsumerServiceUrl: string;
  relayState: string;
};

export type CompanySSOSettingsForm = CompanySSOSettings & {
  ogpSamlAttribute: string;
  workerSamlAttribute: string;
  ogpMetadataFile: File | null;
  workerMetadataFile: File | null;
};

export enum SsoUserGroup {
  OGP = 'OGP',
  WORKER = 'WORKER',
}
